import { createRouter, createWebHistory } from "vue-router";
import TestEntryView from "../views/TestEntryView.vue";
import ChatView from "../views/ChatView.vue";

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "home",
      component: TestEntryView,
    },
    {
      path: "/chat",
      name: "chat",
      component: ChatView,
    },
  ],
});
